/**
 * Brand constants for JS-side styling (charts). Mirrors the CSS palette in src/index.css.
 * Source: https://www.simonloos.nl (Elementor global colours + official logo SVG), fetched 2026-11-04.
 * Chart colours are darkened where needed to reach >= 3:1 contrast against white (WCAG non-text).
 */
export const brand = {
  charcoal: "#212427",
  yellow: "#FAC41F",
  yellowDark: "#8A6A00",
  red: "#ED1C28",
  redDark: "#C0121C",
  navy: "#011640",
  green: "#9AC555",
  greenDark: "#3F6E12",
  grey50: "#F9FAFD",
  grey100: "#F3F5F8",
  grey300: "#C8D5DC",
  border: "#DDE3E8",
  mutedText: "#5B6670",
} as const;

export const chart = {
  grid: "#E6EAEE",
  axis: "#8A949C",
  axisText: "#5B6670",
  /** Main series (e.g. running mean). */
  primary: brand.charcoal,
  /** Secondary series / highlight; gold that keeps 3.3:1 on white. */
  accent: "#B88A00",
  /** Area fill under the main series. */
  areaFill: brand.yellow,
  success: "#4E8A1A",
  failure: brand.red,
  neutral: "#8A949C",
  /** Score 1..5, red → green, each >= 3:1 on white. */
  scores: ["#C0121C", "#D9531E", "#B88A00", "#6F9A2A", "#3F6E12"] as const,
} as const;

export function scoreColor(score: number): string {
  const i = Math.min(5, Math.max(1, Math.round(score))) - 1;
  return chart.scores[i];
}
